import React, { useState, useEffect, useRef } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
// import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function ScrollDialog(props) {
  const [open, setOpen] = useState(false);
  const [scroll] = useState('paper');

  const handleClose = () => {
    // if(props.onModalClose){
      props.onModalClose();
    // }
    setOpen(false);
  };

  const descriptionElementRef = useRef(null);
  useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  useEffect(() => {
    if(props.open !== open){
      setOpen(props.open);
    }
  }, [props.open, setOpen, open]);

  return (
    <Dialog
      fullWidth
      maxWidth={ props.maxWidth || "sm"}
      open={open}
      onClose={handleClose}
      scroll={scroll}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
    >
      <DialogTitle id="scroll-dialog-title">{props.title || ''}</DialogTitle>
      <DialogContent dividers={scroll === 'paper'}>
        {/* <DialogContentText
          id="scroll-dialog-description"
          ref={descriptionElementRef}
          tabIndex={-1}
        > */}
          {props.children}
        {/* </DialogContentText> */}
      </DialogContent>
      {props?.disableActions ? null : <DialogActions>
        <Button onClick={handleClose}>Close</Button>
      </DialogActions>}
    </Dialog>
  );
}
